var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      "chat-paused-flag": _vm.takeover, "chat-duplicate-agent": _vm.duplicateAgent
    }
  }, [(_vm.takeover) ? _c('h6', {
    staticStyle: {
      "margin-top": "-2px",
      "margin-left": "-1px"
    }
  }, [_c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("Agent Takeover Active")])], 1) : _vm._e(), _vm._l((_vm.msgs), function(msg, index) {
    return _c('div', {
      key: index,
      staticClass: "row",
      attrs: {
        "id": msg.chatID
      }
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(msg.fromUser) ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-2"
    }, [_c('img', {
      staticClass: "img-avatar",
      staticStyle: {
        "height": "50px",
        "width": "50px"
      },
      attrs: {
        "src": _vm.profPic
      }
    })]), _c('div', {
      staticClass: "col-md-10"
    }, [_c('p', {
      staticClass: "chat-left text-left"
    }, [(msg.message.imageUrl) ? _c('span', [_c('img', {
      staticStyle: {
        "max-width": "100%"
      },
      attrs: {
        "src": msg.message.imageUrl,
        "alt": msg.message.message
      }
    })]) : _c('span', [_vm._v(_vm._s(msg.message))]), _c('br'), (msg.translatedText) ? _c('span', [_c('i', {
      staticClass: "translatedText"
    }, [_vm._v(_vm._s(msg.translatedText))]), _c('br')]) : _vm._e(), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("sent " + _vm._s(_vm._f("moment")(msg.timestamp, 'from', 'now')) + " from"), (msg.fromUser) ? _c('span', [(msg.platform.bot) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("parseBot")(msg.platform.bot)))]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("parsePlatform")(msg.platform.source)))]) : _vm._e(), _c('div', {
      staticClass: "text-muted float-right"
    }, [(msg.sentimentValue >= 0) ? _c('span', {
      staticClass: "individualSuccessSentiment text-light"
    }, [_vm._v(_vm._s(msg.sentiment) + "  "), _c('span', {
      staticClass: "fa fa-thumbs-o-up"
    })]) : (msg.sentimentValue < 0) ? _c('span', {
      staticClass: "individualDangerSentiment text-light"
    }, [_vm._v(_vm._s(msg.sentiment) + "  "), _c('span', {
      staticClass: "fa fa-thumbs-o-down"
    })]) : _vm._e(), _c('b-button', {
      staticClass: "btn-translate",
      attrs: {
        "variant": "link",
        "no-caret": "no-caret"
      },
      on: {
        "click": function($event) {
          _vm.translate(msg.message, index)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-globe text-muted"
    })])], 1)])])])])]) : (!msg.fromUser) ? _c('div', [_c('div', {
      staticClass: "col-md-6"
    }), (msg.message) ? _c('div', {
      staticClass: "col-md-6 pull-right"
    }, [((msg.message[0].speech && msg.message[0].speech != "") || (msg.message[0].text && msg.message[0].text.text[0]) || (msg.message[0].payload) || typeof msg.message === "string" || (msg.message[0].title) || (msg.message[0].address) || (msg.message[0].elements)) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [_c('p', {
      staticClass: "chat-right text-right"
    }, [(typeof msg.message != "string" && msg.message[0].speech) ? _c('span', [_vm._v(_vm._s(msg.message[0].speech))]) : (typeof msg.message != "string" && msg.message[0].text) ? _c('span', [_vm._v(_vm._s(msg.message[0].text.text[0]))]) : (typeof msg.message != "string" && msg.message[0].quickReplies) ? _c('span', [_vm._v(_vm._s(msg.message[0].title))]) : (typeof msg.message != "string" && msg.message[0].address) ? _c('section', {
      staticClass: "VueCarousel",
      staticStyle: {
        "position": "static"
      }
    }, [_c('div', {
      staticClass: "VueCarousel-wrapper"
    }, [_c('Carousel', {
      attrs: {
        "per-page": 1,
        "paginationPadding": 5,
        "mouseDrag": true
      }
    }, _vm._l((msg.message), function(message) {
      return (message.address) ? _c('slide', {
        key: message.id,
        staticStyle: {
          "margin-bottom": "0px"
        },
        attrs: {
          "tabindex": "-1"
        }
      }, [_c('div', {
        staticClass: "carousel-generic-content"
      }, [_c('img', {
        staticClass: "carousel-generic-image",
        staticStyle: {
          "max-width": "100%",
          "border-bottom": "thin solid rgb(204, 204, 204)"
        },
        attrs: {
          "src": message.picUrl
        }
      }), _c('div', {
        staticClass: "carousel-cart",
        staticStyle: {
          "border-bottom": "thin solid rgb(204, 204, 204)"
        }
      }, [_c('span', {
        staticClass: "carousel-title"
      }, [_vm._v(_vm._s(message.name) + " "), _c('br')]), _c('span', {
        staticClass: "carousel-subtitle"
      }, [_vm._v("Tel: " + _vm._s(message.tel)), _c('br'), _vm._v("Fax: " + _vm._s(message.fax)), _c('br'), _vm._v("Contact Person: " + _vm._s(message.contactPerson)), _c('br'), _vm._v("E-mail: " + _vm._s(message.email))])])])]) : _vm._e()
    }))], 1)]) : (typeof msg.message != "string" && msg.message[0].title) ? _c('section', {
      staticClass: "VueCarousel",
      staticStyle: {
        "position": "static"
      }
    }, [_c('div', {
      staticClass: "VueCarousel-wrapper"
    }, [_c('Carousel', {
      attrs: {
        "per-page": 1,
        "paginationPadding": 5,
        "mouseDrag": true
      }
    }, _vm._l((msg.message), function(message) {
      return _c('slide', {
        key: message.id,
        staticStyle: {
          "margin-bottom": "0px"
        },
        attrs: {
          "tabindex": "-1"
        }
      }, [_c('div', {
        staticClass: "carousel-generic-content"
      }, [_c('img', {
        staticClass: "carousel-generic-image",
        attrs: {
          "src": message.image_url
        }
      }), _c('div', {
        staticClass: "carousel-cart",
        staticStyle: {
          "border-bottom": "thin solid rgb(204, 204, 204)"
        }
      }, [_c('span', {
        staticClass: "carousel-title"
      }, [_vm._v(_vm._s(message.title) + " "), _c('br')]), _c('span', {
        staticClass: "carousel-subtitle"
      }, [_vm._v(_vm._s(message.subtitle) + " "), _c('br')])]), _vm._l((message.buttons), function(button) {
        return _c('div', {
          staticClass: "carousel-generic-button",
          staticStyle: {
            "border-bottom": "thin solid rgb(204, 204, 204), height: 20px"
          }
        }, [_vm._v(_vm._s(button.title) + " "), _c('br')])
      })], 2)])
    }))], 1)]) : (typeof msg.message != "string" && msg.message[0].elements) ? _c('section', {
      staticClass: "carousel message"
    }, [_vm._l((msg.message[0].elements), function(element) {
      return _c('div', {
        staticClass: "carousel-div"
      }, [_c('div', {
        staticClass: "carousel-cart"
      }, [_c('span', {
        staticClass: "carousel-title"
      }, [_vm._v(_vm._s(element.title))]), _c('br'), _c('span', {
        staticClass: "carousel-subtitle"
      }, [_vm._v(_vm._s(element.subtitle))]), _c('br'), _c('br'), _c('span', {
        staticClass: "carousel-list-button"
      }, [_vm._v(_vm._s(element.buttons[0].title))])])])
    }), _c('div', {
      staticClass: "carousel-div-last"
    }, [_c('div', {
      staticClass: "carousel-cart"
    }, [_c('span', {
      staticClass: "carousel-list-button"
    }, [_vm._v(_vm._s(msg.message[0].buttons[0].title))])])])], 2) : _c('span', [_vm._v(_vm._s(msg.message))]), _c('br'), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("sent " + _vm._s(_vm._f("moment")(msg.timestamp, 'from', 'now')) + " from"), (msg.dashboard) ? _c('span', [_c('i', [_vm._v(" Enchatment Engine")])]) : _c('span', [_c('i', [_vm._v(" Bot")])]), (msg.platform) ? _c('span', [_vm._v(" via"), (msg.platform.bot) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("parseBot")(msg.platform.bot)))]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("parsePlatform")(msg.platform.source)))]) : _vm._e()])])]), _c('div', {
      staticClass: "col-md-2"
    }, [_c('img', {
      staticClass: "img-avatar",
      attrs: {
        "src": _vm.botPic
      }
    })])]) : _vm._e()]) : _vm._e()]) : _vm._e()]), (!msg.fromUser && (typeof msg.message != "string" && msg.message[0].quickReplies)) ? _c('div', {
      staticClass: "col md-12"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-2"
    }), _c('div', {
      staticClass: "col-md-10"
    }, [_c('div', {
      staticClass: "row quick-replies"
    }, _vm._l((msg.message[0].quickReplies), function(quickReply) {
      return _c('div', [(_vm.msgs[index + 1] && _vm.msgs[index + 1].fromUser && quickReply === _vm.msgs[index + 1].message && quickReply.content_type) ? _c('div', {
        staticClass: "quick-reply-highlighted"
      }, [_vm._v(_vm._s(quickReply.content_type))]) : (_vm.msgs[index + 1] && _vm.msgs[index + 1].fromUser && quickReply === _vm.msgs[index + 1].message) ? _c('div', {
        staticClass: "quick-reply-highlighted"
      }, [_vm._v(_vm._s(quickReply))]) : (quickReply.content_type) ? _c('div', {
        staticClass: "quick-reply-dimmed"
      }, [_vm._v(_vm._s(quickReply.content_type))]) : _c('div', {
        staticClass: "quick-reply-dimmed"
      }, [_vm._v(_vm._s(quickReply))])])
    }))])])])]) : _vm._e(), _c('div', {
      staticClass: "clearfix"
    })])
  }), (_vm.takeover) ? _c('h6', {
    staticStyle: {
      "margin-bottom": "-2px",
      "margin-left": "-1px"
    }
  }, [_c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("Agent Takeover Active")])], 1) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f07b092","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat.vue
// module id = 1391
// module chunks = 1